export const commonNavigate = (url, navigate) => {
    if (typeof window !== 'undefined' && navigate) {
        if (url.includes(window.location.origin)) {
            const parsedUrl = url.replace(window.location.origin, '')
            navigate(parsedUrl)
        } else {
            window.location.href = url
        }
    }
}
